import { AlertService } from './../../shared/services/alert.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

@Injectable()
export class ModulesGuard implements CanActivate {
  constructor(private _authService: AuthService,
    private _alertService: AlertService,
    private _router: Router
  ) { }
  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    let user = undefined;
    await this._authService.getSession().then((userSession : any) =>{ user = userSession;});
    if (!user) this._router.navigate(['/auth/login']);
    let loadedRouterConfig = next.children[0].routeConfig;
    if (loadedRouterConfig.data) {
      if (!loadedRouterConfig.data.id_modulo) return true;
      let canAccess = user.modulos_contrato.some((item) => item.id_modulo == loadedRouterConfig.data.id_modulo);
      if (!canAccess) {
        this._alertService.openSwal({
          text: 'Actualmente no posees este módulo en tu contratación',
          type: 'warning'
        });
        this._router.navigate(['/menu']);
      }
      return canAccess;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/guards/modules.guard.ts